{
  "nav": {
    "features": "विशेषताएं",
    "formats": "प्रारूप",
    "screenshots": "स्क्रीनशॉट",
    "download": "डाउनलोड",
    "openSource": "ओपन सोर्स",
    "github": "GitHub"
  },
  "hero": {
    "title": "SaiPair",
    "subtitle": "मुफ्त टूर्नामेंट प्रबंधन सॉफ्टवेयर",
    "description": "ओपन-सोर्स, ऑफलाइन डेस्कटॉप ऐप। स्विस, राउंड रॉबिन, एलिमिनेशन और अधिक।",
    "download": "अभी डाउनलोड करें",
    "viewOnGithub": "GitHub पर देखें"
  },
  "features": {
    "title": "विशेषताएं",
    "subtitle": "टूर्नामेंट चलाने के लिए सब कुछ",
    "f1_title": "कई प्रारूप",
    "f1_desc": "स्विस, राउंड रॉबिन, डबल राउंड रॉबिन, सिंगल और डबल एलिमिनेशन।",
    "f2_title": "ऑटो पेयरिंग",
    "f2_desc": "स्मार्ट इंजन तुरंत पेयरिंग बनाता है।",
    "f3_title": "लाइव रैंकिंग",
    "f3_desc": "कॉन्फ़िगर करने योग्य टाईब्रेक नियमों के साथ रियल-टाइम रैंकिंग।",
    "f4_title": "ऑफलाइन फर्स्ट",
    "f4_desc": "इंटरनेट की जरूरत नहीं। सारा डेटा लोकल में।",
    "f5_title": "इंपोर्ट और एक्सपोर्ट",
    "f5_desc": "Excel/CSV से खिलाड़ी इंपोर्ट करें। रैंकिंग और पेयरिंग एक्सपोर्ट करें।",
    "f6_title": "प्रिंट रेडी",
    "f6_desc": "सूचियां, पेयरिंग, रैंकिंग और अधिक प्रिंट करें।",
    "f7_title": "बहुभाषी",
    "f7_desc": "10 भाषाओं में उपलब्ध।",
    "f8_title": "मुफ्त और ओपन सोर्स",
    "f8_desc": "MIT लाइसेंस, हमेशा मुफ्त।"
  },
  "formats": {
    "title": "टूर्नामेंट प्रारूप",
    "subtitle": "सही प्रारूप चुनें",
    "swiss_title": "स्विस सिस्टम",
    "swiss_desc": "हर राउंड में समान स्कोर वाले खिलाड़ियों को जोड़ता है।",
    "roundRobin_title": "राउंड रॉबिन",
    "roundRobin_desc": "हर खिलाड़ी हर दूसरे खिलाड़ी से खेलता है।",
    "elimination_title": "सिंगल एलिमिनेशन",
    "elimination_desc": "हर राउंड में हारने वाले बाहर।",
    "doubleElim_title": "डबल एलिमिनेशन",
    "doubleElim_desc": "खिलाड़ियों को दूसरा मौका मिलता है।"
  },
  "screenshots": {
    "title": "स्क्रीनशॉट",
    "subtitle": "SaiPair को एक्शन में देखें",
    "placeholder": "स्क्रीनशॉट जल्द आ रहे हैं — डाउनलोड करके आज़माएं!"
  },
  "download": {
    "title": "डाउनलोड",
    "subtitle": "Windows, macOS और Linux के लिए उपलब्ध",
    "windows": "Windows",
    "macos": "macOS",
    "linux": "Linux",
    "getLatest": "नवीनतम संस्करण डाउनलोड करें",
    "allReleases": "सभी रिलीज़ देखें"
  },
  "openSource": {
    "title": "ओपन सोर्स",
    "subtitle": "खुले तौर पर निर्मित, MIT लाइसेंस",
    "description": "SaiPair मुफ्त और ओपन-सोर्स सॉफ्टवेयर है। सभी का स्वागत है।",
    "github": "GitHub रिपॉजिटरी",
    "issues": "समस्या रिपोर्ट करें",
    "discussions": "चर्चा में शामिल हों"
  },
  "footer": {
    "copyright": "© {{year}} SaiPair. MIT लाइसेंस।",
    "madeWith": "दुनिया भर के टूर्नामेंट आयोजकों के लिए ❤ से बनाया।"
  },
  "language": {
    "en": "English",
    "zh-CN": "中文",
    "es": "Español",
    "fr": "Français",
    "pt": "Português",
    "ru": "Русский",
    "ja": "日本語",
    "ar": "العربية",
    "hi": "हिन्दी",
    "bn": "বাংলা"
  }
}
